import { render, staticRenderFns } from "./PanelResumeCertifications.vue?vue&type=template&id=20af18e8&scoped=true&"
import script from "./PanelResumeCertifications.vue?vue&type=script&lang=js&"
export * from "./PanelResumeCertifications.vue?vue&type=script&lang=js&"
import style0 from "./PanelResumeCertifications.vue?vue&type=style&index=0&id=20af18e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20af18e8",
  null
  
)

export default component.exports